import { useQuery, useQueryClient } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

export interface PropertyManagerBuilding {
  id: number
  name: string
}

export interface PropertyManagerUser {
  avatar: string | null
  email: string
  firstName: string
  isActive: boolean
  lastName: string
}

export interface PropertyManager {
  buildingIds: PropertyManagerBuilding[]
  createdAt: number
  id: number
  jobTitle: string | null
  phone: number | null
  user: PropertyManagerUser
}

export const USE_GET_PROPERTY_MANAGERS_QUERY_KEY = 'useGetPropertyManagers'

export const getPropertyManagers = async (signal?: AbortSignal) => {
  const response = await authAPI.get<PropertyManager[]>('/propertyManager/all', { signal })
  return response.data
}

export const useGetPropertyManagers = () => {
  return useQuery({
    queryFn: ({ signal }) => getPropertyManagers(signal),
    queryKey: [USE_GET_PROPERTY_MANAGERS_QUERY_KEY],
  })
}

export const useInvalidatePropertyManagers = () => {
  const queryClient = useQueryClient()
  return () => queryClient.invalidateQueries({ queryKey: [USE_GET_PROPERTY_MANAGERS_QUERY_KEY] })
}
